<template>
  <Main>
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-5" shaped>
            <v-row dense>
              <v-col cols="12">
                <strong>UNMAPPING SALES</strong>
              </v-col>
            </v-row>
            <hr />
            <v-row class="mt-4">
              <v-col cols="12" md="auto">Branch :</v-col>
              <v-col cols="6" md="3">
                <v-autocomplete
                  color="red darken-1"
                  v-model="branch"
                  :items="branchList"
                  item-text="BRANCH_CODE"
                  :return-object="true"
                  label="Choose"
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="6" md="3">
                <v-btn
                  @click="filterDataTable"
                  outlined
                  color="indigo lighten-1"
                  :disabled="dtLoading"
                  >Load List</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card class="pa-3" outlined>
                  <v-card-title>
                    Unmapping Sales List
                    <v-btn
                      class="ml-2"
                      @click="dowloadCSV()"
                      outlined
                      color="indigo lighten-1"
                      :disabled="dtLoading"
                      >Export Data</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-text-field
                      color="red darken-1"
                      v-model="searchRole"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                    :headers="dtHeaders"
                    :items="dtItems"
                    :search="searchRole"
                    :loading="dtLoading"
                    loading-text="Fetching Data..."
                    dense
                  >
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import moment from "moment";
import XLSX from "xlsx";

const dtHeaders = [
  {
    text: "Customer ID",
    value: "CUSTOMER_ID",
  },
  {
    text: "Customer Name",
    value: "CUSTOMER_NAME",
  },
  {
    text: "Channel",
    value: "CHANNEL",
  },
  {
    text: "Cat Businnes",
    value: "CATBISNIS",
  },
  // {
  //   text: "Trx Date",
  //   value: "TRX_DATE",
  // },
  {
    text: "Invoice Value",
    value: "VAL",
  }
];

export default {
  components: {
    Main,
  },
  data() {
    return {
      isLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      branchList: [],
      branch: null,
      searchRole: "",
      dtLoading: false,
      dtHeaders,
      dtItems: [],
      position: "",
    };
  },
  mounted() {
    this.loadBranchList();
  },
  methods: {
    dowloadCSV() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(this.dtItems);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Unmapping Sales.xlsx"); // initiate a file download in browser
    },
    loadBranchList() {
      this.isLoading = true;
      this.$http
        .get("/structure/role/getBranchList", {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          if (!res.data.success || res.data.success == undefined) {
            console.log(res);
          }
          this.isLoading = false;
          let { data } = res.data;
          data.unshift({
            ORG_ID: -1,
            BRANCH_CODE: "ALL BRANCH",
            BRANCH_DESC: "ALL BRANCH",
          });
          this.branch = data[0];
          const orgID = JSON.parse(localStorage.getItem("userData")).ORG_ID;
          if(orgID==81){
            this.branchList = data;
          }else{            
            var newArray = data.filter(function (el) {
                return el.ORG_ID == orgID
            });
            this.branchList = newArray;
          }
          this.filterDataTable();
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err.toString());
        });
    },
    filterDataTable() {
      this.dtLoading = true;
      const data = {
        orgID: this.branch.ORG_ID == "ALL BRANCH" ? 0 : this.branch.ORG_ID
      };
      
      this.$http
        .post("/mapping-sales-assignment/overviewUnmapSales", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          if (!res.data.success || res.data.success == undefined) {
            console.log(res);
          }
          let { data } = res.data;
          console.log('data rizki ', data)
          if (data.length <= 0) {
            this.dtLoading = false;
            this.dtItems = [];
          }else{
            data.forEach((obj, index) => {
              data[index].VAL = data[index].VAL.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
           });
          }
         
          this.dtLoading = false;
          this.dtItems = data;
        })
        .catch((err) => {
          this.dtLoading = false;
          this.showSnackbar(err.toString());
        });
    },  
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
